import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { MODAL_ADMIN_CHANGE_CODE } from 'redux/modules/modals'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import NumComponent from 'components/numPad/NumComponent'
const styles = theme => ({
  textField: {
    height: 40
  },
  paper: {
    minWidth: 200,
    minHeight: 40,
    marginBottom: 10
  },
  textFieldInput: {
    fontSize: '30px',
    width: '100%',
    height: '100%'
  },
  input: {
    padding: 0
  }
})
const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0]
class ChangeAdminCodeModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    changeAdminCode: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired
  }
  state = {
    value: ''
  }
  handleClick = value => {
    let newValue = `${this.state.value}${value}`
    let error
    if (newValue.length === 4) {
      this.props.changeAdminCode(newValue)
      this.props.hideModal(MODAL_ADMIN_CHANGE_CODE)
    }
    this.setState({ value: newValue, error: error })
  }

  render() {
    const { classes } = this.props
    return (
      <ModalWrapper
        appBar
        open
        title={`Administration`}
        showCancel
        showOk={false}>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="space-around">
          <Grid
            item
            xs={12}
            container
            direction="column"
            alignItems="center"
            justify="center">
            <Grid item xs={8}>
              <Paper elevation={3} className={classes.paper}>
                <Grid container alignItems="center" justify="center">
                  <Grid item xs={6} md={4}>
                    <Typography variant="title">{this.state.value}</Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
            {this.state.error && (
              <Typography variant="caption" color="secondary" gutterBottom>
                {this.state.error}
              </Typography>
            )}
            <Grid
              style={{ maxWidth: 400 }}
              item
              xs={12}
              md={12}
              container
              direction="row"
              alignItems="center"
              justify="center"
              spacing={40}>
              {numbers.map((value, index) => {
                return (
                  <Grid key={index} item xs={4} md={4}>
                    <NumComponent onClick={this.handleClick} value={value} />
                  </Grid>
                )
              })}
            </Grid>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(ChangeAdminCodeModal)



// WEBPACK FOOTER //
// ./src/routes/Admin/Settings/components/general/ChangeAdminCodeModal.js